module.exports = __webpack_public_path__ + "media/images/icon-svg/whatsapp-1e9f0f1f8bd3603e6b108fe18d0bef2f.svg";